import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=3eac768b&scoped=true"
import script from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=3eac768b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eac768b",
  null
  
)

export default component.exports